/* eslint-disable no-unreachable */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Button, Drawer, Modal, message, Dropdown } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { useConnectWallet, useActiveWeb3React } from "../../hooks";
import { NEED_A_PLACEHOLDER, WALLET_LIST } from "../../constants/index";
import WalletItem from "./WalletItem";
import { useWeb3React } from "@web3-react/core";
import web3 from "web3";
import "antd/dist/antd.min.css";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { useHook } from './store'

import { useTranslation } from "react-i18next";
import i18next from "i18next";

import cn from "../cn/common.json";
import en from "../en/common.json";
import po from "../po/common.json";
import axios from "axios";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en",
  resources: {
    en: {
      common: en,
    },
    cn: {
      common: cn,
    },
    po: {
      common: po,
    },
  },
});

const renderChain = (chain: any) => {
  switch (chain) {
    case '0x38':
      return 56
      break;
    case '0x1':
      return 1
      break;
    case '0xa4b1':
      return 42161
      break;
    case '0xa86a':
      return 43114
      break;
    case '0xa':
      return 10
      break;
    case '0x89':
      return 137
      break;
    case '0x2105':
      return 8453
      break;
    case '0xfa':
      return 250
      break;
    case '0x42':
      return 66
      break;
    default:
      return ''
      break;
  }
}

declare const window: Window & typeof globalThis & { ethereum: any; trustwallet: any; bitkeep: any; okxwallet: any; safepalProvider: any; safepal: any };
const ConnectWallet = (props: any) => {
  const [state, actions]: any = useHook();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const { t, i18n }: any = useTranslation("common");
  const { walletLogin, walletLogout } = useConnectWallet();
  const walletItemClass = "w-1/3 flex-auto mb-0.5 p-0.5 last:bg-transparent";
  const { chainId }: any = useWeb3React();
  const context = useWeb3React();
  const { active } = context;
  const { account } = useActiveWeb3React();

  const provider = "https://avalanche.public-rpc.com";
  let chain = localStorage.getItem("chainText");
  let w3: any = "";
  if (typeof window !== "undefined") {
    w3 = window.ethereum ? new web3(window.ethereum) : new web3(provider);
  }

  const [bnbBalance, setBnbBalance] = useState(0);
  const [usdPrice, setusdPrice] = useState(0);

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("valuelang"));
  }, []);

  useEffect(() => {
    if (account) {
      w3.eth.getBalance(account, (err: any, balance: any) => {
        if (balance) {
          let _balance: any = web3.utils.fromWei(
            web3.utils.toBN(balance),
            "ether"
          );
          let bnbBl = Math.round(parseFloat(_balance) * 10000) / 10000;
          setBnbBalance(bnbBl);
        }
      });
    }
  }, [account]);



  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const [isModalVisibleAcc, setIsModalVisibleAcc] = useState<boolean>(false);

  const showModalAccount = () => {
    setIsModalVisibleAcc(true);
  };

  const handleOkAccount = () => {
    setIsModalVisibleAcc(false);
  };

  const handleCancelAccount = () => {
    setIsModalVisibleAcc(false);
  };

  const [open, setOpen] = useState(false);
  const [openAcc, setOpenAcc] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const accountEllipsis = active
    ? `${account?.substring(0, 4)}...${account?.substring(account.length - 4)}`
    : "Connect Wallet";
  const accountEllipsisWl = active
    ? `${account?.substring(0, 5)}...${account?.substring(account.length - 5)}`
    : "Connect Wallet";

  const handleDisconnect = () => {
    walletLogout();
    setIsModalVisibleAcc(false);

    setSelectedAccountBit('');
    localStorage.removeItem('connectorId')
    setSelectedAccount('');
    // window.location.reload()
  };

  const handleConnect = async (connectorId: string) => {
    console.log('connectorId -------->', connectorId)
    try {
      const rs = await walletLogin(connectorId);

      setIsModalVisible(false);
    } catch (e) {
      console.error("Login failed");
    }
  };

  let navigate = useNavigate();
  const gotoMyNFT = () => {
    navigate('/my-nft');
  }



  const titleWallet = (
    <>
      <div className="logo-wallet">
        <div className="box-logo">
          <img src="../images/logo.svg" alt="" />
        </div>
      </div>
    </>
  );

  const gotoScan = () => {
    window.open(`https://snowtrace.dev/address/${account}`)
  }

  // START TRUST-------------------------------------------------
  const [initializing, setInitializing] = React.useState(true);
  const [injectedProvider, setInjectedProvider]: any = React.useState(null);
  const [initializationError, setInitializationError] = React.useState("");

  const [connected, setConnected] = React.useState(false);
  const [selectedAccountTrust, setSelectedAccount] = React.useState("");
  const [chainIdNew, setChainId] = React.useState("");
  const [error, setError] = React.useState("");

  let checkConnector = localStorage.getItem("connectorId")



  async function getTrustWalletInjectedProvider(
    { timeout } = { timeout: 3000 }
  ) {
    const provider = getTrustWalletFromWindow();

    if (provider) {
      return provider;
    }

    return listenForTrustWalletInitialized({ timeout });
  }

  async function listenForTrustWalletInitialized(
    { timeout } = { timeout: 3000 }
  ) {
    return new Promise((resolve) => {
      const handleInitialization = () => {
        resolve(getTrustWalletFromWindow());
      };

      window.addEventListener("trustwallet#initialized", handleInitialization, {
        once: true,
      });

      setTimeout(() => {
        window.removeEventListener(
          "trustwallet#initialized",
          handleInitialization
        );
        resolve(null);
      }, timeout);
    });
  }

  function getTrustWalletFromWindow() {
    const isTrustWallet = (ethereum: any) => {
      // Identify if Trust Wallet injected provider is present.
      const trustWallet = !!ethereum.isTrust;

      return trustWallet;
    };

    const injectedProviderExist =
      typeof window !== "undefined" && typeof window.ethereum !== "undefined";

    // No injected providers exist.
    if (!injectedProviderExist) {
      return null;
    }

    // Trust Wallet was injected into window.ethereum.
    if (isTrustWallet(window.ethereum)) {
      return window.ethereum;
    }

    // Trust Wallet provider might be replaced by another
    // injected provider, check the providers array.
    if (window.ethereum?.providers) {
      // ethereum.providers array is a non-standard way to
      // preserve multiple injected providers. Eventually, EIP-5749
      // will become a living standard and we will have to update this.
      return window.ethereum.providers.find(isTrustWallet) ?? null;
    }

    // Trust Wallet injected provider is available in the global scope.
    // There are cases that some cases injected providers can replace window.ethereum
    // without updating the ethereum.providers array. To prevent issues where
    // the TW connector does not recognize the provider when TW extension is installed,
    // we begin our checks by relying on TW's global object.
    return window["trustwallet"] ?? null;
  }

  useEffect(() => {
    const initializeInjectedProvider = async () => {
      const trustWallet = await getTrustWalletInjectedProvider();

      if (!trustWallet) {
        setInitializationError("Trust Wallet is not installed.");
        setInitializing(false);
        return;
      }

      setInjectedProvider(trustWallet);
      setInitializing(false);
    };

    initializeInjectedProvider();
  }, [])

  const handleConnectTrustWallet = async (connectorId: any) => {
    try {
      setError("");
      if (!injectedProvider) {
        window.open('https://chromewebstore.google.com/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph')
      }

      const accounts = await injectedProvider.request({
        method: "eth_requestAccounts",
      });

      const chainId1 = await injectedProvider.request({ method: "eth_chainId" });
      localStorage.setItem('connectorId', connectorId)
      setSelectedAccount(accounts[0]);

      setChainId(chainId1);
      setConnected(true);
      setIsModalVisible(false);
      setSelectedAccountBit('')
      setSelectedAccountOKX('')


    } catch (e: any) {
      console.error(e);
      if (e.code === 4001) {
        setError("User denied connection.");
      }
    }
  }

  const handleDisConnectTrustWallet = async (connectorId: any) => {
    setIsModalVisibleAcc(false);
    setConnected(false);
    setSelectedAccount('');
    setChainId('');

    localStorage.removeItem('connectorId')
    setSelectedAccountBit('');
    setSelectedAccountOKX('')
    window.location.reload()
  }

  const switchChain = async () => {
    try {
      await injectedProvider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x1" }],
      });
    } catch (e: any) {
      console.error(e);
      if (e.code === 4001) {
        setError("User rejected switching chains.");
      }
    }
  };


  useEffect(() => {
    if (injectedProvider && checkConnector === 'trustWallet') {
      injectedProvider?.on("accountsChanged", (accounts: any) => {
        if (accounts.length === 0) {
          setConnected(false);
          setSelectedAccount("");
          localStorage.removeItem('connectorId')
          setSelectedAccountBit('');
          setSelectedAccountOKX('')
          setChainId("");
        } else {
          const connectedAccount = accounts[0];
          setSelectedAccount(connectedAccount);
        }
      });
      injectedProvider?.on("chainChanged", setChainId);

    }
  }, [injectedProvider])

  const getAccountTrust = async () => {
    const accounts = await injectedProvider.request({
      method: "eth_accounts",
    });

    if (accounts?.length !== 0) {

      setSelectedAccount(accounts[0])
    } else {
      setSelectedAccount("")
    }
    const chainId1 = await injectedProvider.request({ method: "eth_chainId" });
    setChainId(chainId1);

  }

  useEffect(() => {
    if (injectedProvider && checkConnector === 'trustWallet') {
      getAccountTrust()

    }

  }, [injectedProvider])

  // END TRUST---------------------------------------------------


  // START BIT---------------------------------------------------
  const [selectedAccountBit, setSelectedAccountBit] = React.useState("");

  const providerBit = window?.bitkeep && window?.bitkeep?.ethereum;

  const getAccountBit = async () => {
    const accounts = await providerBit.request({
      method: "eth_accounts",
    });
    if (accounts?.length !== 0) {
      setSelectedAccountBit(accounts[0])
    } else {
      setSelectedAccountBit("")
    }

    const chainId1 = await providerBit.request({ method: "eth_chainId" });
    setChainId(chainId1)

  }

  useEffect(() => {
    if (providerBit && checkConnector === 'bit') {
      getAccountBit()
    }
  }, [providerBit])

  const handleConnectBit = async (connectorId: any) => {
    try {
      if (!providerBit) {
        window.open('https://web3.bitget.com/en/wallet-download?type=2');
      } else {
        providerBit.request({
          method: "eth_requestAccounts"
        }).then((accounts: any) => {
          setSelectedAccountBit(accounts[0])
          localStorage.setItem('connectorId', connectorId)
          setIsModalVisible(false);
          setSelectedAccount('')
          setSelectedAccountOKX('')
          //success
        }).catch((error: any) => {
          setSelectedAccountBit('')
          localStorage.removeItem('connectorId')
          setIsModalVisible(false);
          //fail
        });
        const chainId1 = await providerBit.request({ method: "eth_chainId" });
        setChainId(chainId1)
      }

    } catch (error) {
      console.log('error', error)
    }
  }

  const handleDisconnectBit = () => {
    setIsModalVisibleAcc(false);
    setSelectedAccountBit('');
    localStorage.removeItem('connectorId')
    setSelectedAccount('')
    setSelectedAccountOKX('')
    setChainId('')
    // window.location.reload()
  }

  useEffect(() => {
    if (providerBit) {
      providerBit.on('accountsChanged', (accounts: any) => {
        //success
        if (accounts.length === 0) {
          setSelectedAccountBit("");
          localStorage.removeItem('connectorId')
          setSelectedAccount('');
          setSelectedAccountOKX('')
        } else {
          setSelectedAccountBit(accounts[0])
        }
      });
    }

  }, [providerBit])


  useEffect(() => {
    if (providerBit) {
      providerBit.on('chainChanged', (chainId: any) => {
        setChainId(chainId)
      });
    }
  }, [providerBit])



  //--OKX------------------------------------------------------------
  const [selectedAccountOKX, setSelectedAccountOKX] = React.useState("");

  const getAccountOKX = async () => {
    const accounts = await window?.okxwallet.request({
      method: "eth_accounts",
    });
    if (accounts?.length !== 0) {
      setSelectedAccountOKX(accounts[0])
    } else {
      setSelectedAccountOKX("")
    }
    const chainId1 = await window?.okxwallet.request({ method: "eth_chainId" });
    setChainId(chainId1)

  }
  useEffect(() => {
    if (window?.okxwallet && checkConnector === 'okx') {
      getAccountOKX()
    }
  }, [window?.okxwallet])

  const detectOKXWallet = () => {
    if (typeof window?.okxwallet !== 'undefined') {
      console.log('OKX is installed!')
    }
    else {
      window.open('https://chromewebstore.google.com/detail/v%C3%AD-okx-web3/mcohilncbfahbmgdjkbpemcciiolgcge')
    }
  }
  const handleConnectOKX = async (connectorId: any) => {
    detectOKXWallet()
    window?.okxwallet
      .request({ method: "eth_requestAccounts" })
      .then((res: any) => {
        console.log('res', res)
        setSelectedAccountOKX(res[0])
        localStorage.setItem('connectorId', connectorId)
        setIsModalVisible(false);
        setSelectedAccount('')
        setSelectedAccountBit('')

      })
      .catch((err: any) => {
        if (err.code === 4001) {
          // EIP-1193 userRejectedRequest error
          // If this happens, the user rejected the connection request.
          console.log("Please connect to OKX Wallet.");
        } else {
          console.error(err);
        }
      });

    const chainId1 = await window?.okxwallet.request({ method: "eth_chainId" });
    setChainId(chainId1)

  }
  const handleDisconnectOKX = () => {
    setIsModalVisibleAcc(false);
    setSelectedAccountOKX('');
    localStorage.removeItem('connectorId')
    setSelectedAccount('')
    setSelectedAccountBit('')
    setChainId('')
    window.location.reload()
  }
  useEffect(() => {
    if (window?.okxwallet) {
      window?.okxwallet.on('accountsChanged', (accounts: any) => {
        //success
        setSelectedAccountOKX(accounts[0])
        // const account = accounts[0];
      });
      window?.okxwallet.on('disconnect', (accounts: any) => {
        //success
        setSelectedAccountOKX('')
        localStorage.removeItem('connectorId')
        setSelectedAccount('')
        setSelectedAccountBit('')
        window.location.reload()
        // const account = accounts[0];
      });
    }
  }, [window?.okxwallet])
  useEffect(() => {
    if (window?.okxwallet) {
      window?.okxwallet.on('chainChanged', (chainId: any) => {
        setChainId(chainId)
      });
    }

  }, [window?.okxwallet])
  //--OKX------------------------------------------------------------



  //--SAFE------------------------------------------------------------

  const [selectedAccountSafe, setSelectedAccountSafe] = React.useState("");

  const getAccountSafe = async () => {
    const accounts = await window?.safepalProvider.request({
      method: "eth_accounts",
    });
    if (accounts?.length !== 0) {
      setSelectedAccountSafe(accounts[0])
    } else {
      setSelectedAccountSafe("")
    }
    const chainId1 = await window?.safepalProvider.request({ method: "eth_chainId" });
    setChainId(chainId1)
  }
  useEffect(() => {
    if (window?.safepalProvider && checkConnector === 'safe') {
      getAccountSafe()
    }
  }, [window?.safepalProvider])

  const detectSafeWallet = () => {
    if (typeof window?.safepalProvider !== 'undefined') {
      console.log('safe is installed!')
    }
    else {
      window.open('https://chromewebstore.google.com/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa')
    }
  }
  const handleConnectSafe = async (connectorId: any) => {
    console.log('connectorId', connectorId)
    detectSafeWallet()
    window?.safepalProvider
      .request({ method: "eth_requestAccounts" })
      .then(async (res: any) => {
        console.log('res', res)
        setSelectedAccountSafe(res[0])
        localStorage.setItem('connectorId', connectorId)
        setIsModalVisible(false);
        setSelectedAccount('')
        setSelectedAccountBit('')
        setSelectedAccountOKX('')
      })
      .catch((err: any) => {
        if (err.code === 4001) {
          // EIP-1193 userRejectedRequest error
          // If this happens, the user rejected the connection request.
          console.log("Please connect to OKX Wallet.");
        } else {
          console.error(err);
        }
      });

    const chainId1 = await window?.safepalProvider.request({ method: "eth_chainId" });
    setChainId(chainId1)

  }
  const handleDisconnectSafe = () => {
    setIsModalVisibleAcc(false);
    setSelectedAccountSafe('');
    localStorage.removeItem('connectorId')
    setSelectedAccount('')
    setSelectedAccountBit('')
    setSelectedAccountOKX('')
    setChainId('')
    window.location.reload()
  }

  useEffect(() => {
    if (window?.safepalProvider) {
      window?.safepalProvider.on('accountsChanged', (accounts: any) => {
        console.log('accountsChanged', accounts)
        //success
        setSelectedAccountSafe(accounts[0])
        // const account = accounts[0];
      });
      window?.safepalProvider.on('disconnect', (accounts: any) => {
        //success
        setSelectedAccountSafe('');
        setSelectedAccountOKX('')
        localStorage.removeItem('connectorId')
        setSelectedAccount('')
        setSelectedAccountBit('')
        window.location.reload()
        // const account = accounts[0];
      });
    }
  }, [window?.safepalProvider])
  useEffect(() => {
    if (window?.safepalProvider) {
      window?.safepalProvider.on('chainChanged', (chainId: any) => {
        setChainId(chainId)
      });
    }

  }, [window?.safepalProvider])
  //--OKX------------------------------------------------------------

  useEffect(() => {
    if (account) {
      actions.updateAcc(account)
    } else if (selectedAccountBit) {
      actions.updateAcc(selectedAccountBit)

    } else if (selectedAccountTrust) {
      actions.updateAcc(selectedAccountTrust)
    } else if (selectedAccountOKX) {
      actions.updateAcc(selectedAccountOKX)
    } else if (selectedAccountSafe) {
      actions.updateAcc(selectedAccountSafe)
    } else {
      actions.updateAcc('')
    }
  }, [account, selectedAccountTrust, selectedAccountBit, selectedAccountOKX, selectedAccountSafe])

  useEffect(() => {
    if (!account) {
      actions.updateNet(renderChain(chainIdNew))
    }
  }, [chainIdNew, account, account, selectedAccountTrust, selectedAccountBit, selectedAccountOKX, selectedAccountSafe])



  const GetPriceOKX = async (chainId: any, tokenAddress: any) => {
    let OKLINK_API_KEY = "f66ae46a-9fdc-4030-8f21-63c8ee2ab957"
    return new Promise(async (resolve, reject) => {
      await axios.get(`https://www.oklink.com/api/v5/explorer/tokenprice/price-multi`,
        {
          params: {
            chainId: chainId,
            tokenContractAddress: tokenAddress
          },
          headers: {
            'OK-ACCESS-KEY': OKLINK_API_KEY,
          }
        })
        .then((msg) => {
          setusdPrice(Number(msg.data.data[0].lastPrice))
          resolve(msg.data.data[0].lastPrice)
        })
        .catch(err => {
          reject(err)
        })
    })
  };


  useEffect(() => {
    GetPriceOKX(43114, '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7')
  }, [account])

  const items = (
    <div className="modal-dis-new">
      <div className="top-dis">
        <div className="left-dis">
          <img className="icon-meme" src="../images/icon-meme.png" alt="" />
          <div className="dis1">
            <span>Wallet connected</span>
            <span className="dis1-add" onClick={gotoScan}>
              {selectedAccountTrust ? (
                <>
                  {selectedAccountTrust?.slice(0, 4)}...{selectedAccountTrust?.slice(-4)}
                </>
              ) : (
                <>
                  {selectedAccountBit ? (
                    <>
                      {selectedAccountBit?.slice(0, 4)}...{selectedAccountBit?.slice(-4)}
                    </>

                  ) : (
                    <>
                      {selectedAccountOKX ? (
                        <>
                          {selectedAccountOKX?.slice(0, 4)}...{selectedAccountOKX?.slice(-4)}
                        </>
                      ) : (
                        <>
                          {selectedAccountSafe ? (
                            <>
                              {selectedAccountSafe?.slice(0, 4)}...{selectedAccountSafe?.slice(-4)}
                            </>
                          ) : (
                            <>
                              {account?.slice(0, 4)}...{account?.slice(-4)}
                            </>
                          )}

                        </>
                      )}

                    </>
                  )}

                </>
              )}
              {/* {account?.slice(0, 4)}...{account?.slice(-4)} */}
              <img src="../images/link-add.png" alt="" />
            </span>
          </div>
        </div>

        <div className="dis2">
          {checkConnector === 'trustWallet' ? (
            <button onClick={handleDisConnectTrustWallet}>
              Disconnect
              <img src="../images/icon-dis.png" alt="" />
            </button>
          ) : (
            <>
              {checkConnector === 'bit' ? (
                <>
                  <button onClick={handleDisconnectBit}>
                    Disconnect
                    <img src="../images/icon-dis.png" alt="" />
                  </button>
                </>

              ) : (
                <>
                  {checkConnector === 'okx' ? (
                    <>
                      <button onClick={handleDisconnectOKX}>
                        Disconnect
                        <img src="../images/icon-dis.png" alt="" />
                      </button>
                    </>
                  ) : (
                    <>
                      {checkConnector === 'safe' ? (
                        <button onClick={handleDisconnectSafe}>
                          Disconnect
                          <img src="../images/icon-dis.png" alt="" />
                        </button>
                      ) : (
                        <button onClick={handleDisconnect}>
                          Disconnect
                          <img src="../images/icon-dis.png" alt="" />
                        </button>
                      )}

                    </>
                  )}

                </>

              )}
            </>

          )}
          {/* <button onClick={handleDisconnect}>
            Disconnect
            <img src="../images/icon-dis.png" alt="" />
          </button> */}

        </div>
      </div>
      <div className="top-dis2">
        <div className="dis2-left">
          <img src="../images/avax-add.png" alt="" />
          <div className="top-dis2-text">
            <span className="top-dis2-text1">AVAX</span>
            <span className="top-dis2-text2">Avalanche C-Chain</span>
          </div>
        </div>
        <div className="dis2-right">
          <div className="dis2-num1">{bnbBalance}</div>
          <div className="dis2-num2">${(bnbBalance * usdPrice)?.toFixed(3)}</div>
        </div>

      </div>
      {/* <div className="top-dis3">
        <img src="../images/my-pro.png" alt="" />
        <span>My Profile</span>
      </div>
      <div className="top-dis3">
        <img src="../images/my-lau.png" alt="" />
        <span>Launch Pool</span>
      </div> */}
      <div className="top-dis3" onClick={gotoMyNFT}>
        <img src="../images/my-nft.png" alt="" />
        <span>My NFTs</span>
      </div>

    </div>
  )
  return (
    <>
      {active || selectedAccountTrust || selectedAccountBit || selectedAccountOKX || selectedAccountSafe ? (
        <>
          {/* @ts-ignore this lib is incompatible with react18  */}
          <Dropdown
            // trigger={['click']}
            overlay={
              items
            }
            placement="bottomRight"
          >

            <div className="btn-connect"
            // onClick={showModalAccount}
            >
              <div className="txt-r">
                <div className="address-header"
                // onClick={showModal}
                >
                  <img src="../images/avax-add.png" alt="" />
                  {account ? (
                    <>
                      {account?.slice(0, 4)}...{account?.slice(-4)}
                    </>
                  ) : (
                    <>
                      {selectedAccountTrust ? (
                        <>
                          {selectedAccountTrust?.slice(0, 4)}...{selectedAccountTrust?.slice(-4)}
                        </>
                      ) : (
                        <>
                          {selectedAccountOKX ? (
                            <>
                              {selectedAccountOKX?.slice(0, 4)}...{selectedAccountOKX?.slice(-4)}
                            </>
                          ) : (
                            <>
                              {selectedAccountSafe ? (
                                <>
                                  {selectedAccountSafe?.slice(0, 4)}...{selectedAccountSafe?.slice(-4)}
                                </>
                              ) : (
                                <>
                                  {selectedAccountBit?.slice(0, 4)}...{selectedAccountBit?.slice(-4)}
                                </>
                              )}

                            </>
                          )}

                        </>
                      )}

                    </>
                  )}
                  {/* {account?.slice(0, 4)}...{account?.slice(-4)} */}

                  <img src="../images/arr.png" alt="" />

                </div>

              </div>
            </div>
          </Dropdown>

        </>
      ) : (
        <>
          <button className="btn-connectnew" onClick={showModal}>
            {t("content.t-36", { framework: "React" })}
          </button>
        </>
      )}

      <Modal
        title="Your wallet"
        open={isModalVisibleAcc}
        onOk={handleOkAccount}
        footer={false}
        onCancel={handleCancelAccount}
        className="connect-wallet modal-wallet"
      >
        <div className="gr-disconect">
          <button
            type="button"
            className="btn-dis-hold"
            onClick={handleDisconnect}
          >
            <img src="../images/logout.png" alt="" /> Disconnect
          </button>
        </div>
      </Modal>

      {!active ? (
        <Modal
          title={
            <div className="text-md connect-wallet-title">
              {!account ? (
                <><img src="./images/connect-text.svg" alt="" /></>
              ) : (
                "Note"
              )}
            </div>
          }
          open={isModalVisible}
          onOk={handleOk}
          footer={false}
          onCancel={handleCancel}
          className="connect-wallet"
        >
          <div className="flex flex-wrap">
            {WALLET_LIST.map((wallet) => {
              return (
                <>

                  {wallet.connectorId === 'trustWallet' ? (
                    <WalletItem
                      className={`wallet-item`}
                      key={wallet.title}
                      onClick={() => handleConnectTrustWallet(wallet.connectorId)}
                      icon={<wallet.icon width="48px" />}
                      title={wallet.title}
                    />
                  ) : (
                    <>
                      {wallet.connectorId === 'bit' ? (
                        <WalletItem
                          className={`wallet-item`}
                          key={wallet.title}
                          onClick={() => handleConnectBit(wallet.connectorId)}
                          icon={<wallet.icon width="48px" />}
                          title={wallet.title}
                        />
                      ) : (
                        <>
                          {wallet.connectorId === 'okx' ? (
                            <WalletItem
                              className={`wallet-item`}
                              key={wallet.title}
                              onClick={() => handleConnectOKX(wallet.connectorId)}
                              icon={<wallet.icon width="48px" />}
                              title={wallet.title}
                            />
                          ) : (
                            <>
                              {wallet.connectorId === 'safe' ? (
                                <WalletItem
                                  className={`wallet-item`}
                                  key={wallet.title}
                                  onClick={() => handleConnectSafe(wallet.connectorId)}
                                  icon={<wallet.icon width="48px" />}
                                  title={wallet.title}
                                />
                              ) : (
                                <WalletItem
                                  className={`wallet-item`}
                                  key={wallet.title}
                                  onClick={() => handleConnect(wallet.connectorId)}
                                  icon={<wallet.icon width="48px" />}
                                  title={wallet.title}
                                />
                              )}
                            </>

                          )}
                        </>

                      )}
                    </>

                  )}
                </>

              );
            })}
            {NEED_A_PLACEHOLDER && <div className={walletItemClass} />}
          </div>
        </Modal>
      ) : (
        ""
      )}
    </>
  );
};

export default ConnectWallet;
